export default __webpack_public_path__ + "static/media/oscer-professor.b34ad625.svg";